const listUpdates = [
  {
    id: `update07012025`,
    tittle: `Actualizaciones Visuales y Nuevas Funcionalidades`,
    date: `08/01/2025`,
    file: `update25012024.js`
  },
  {
    id: `update25012024`,
    tittle: `Actualizaciones Visuales y Nuevas Funcionalidades`,
    date: `24/01/2024`,
    file: `update25012024.js`
  },
  {
    id: `update02112023`,
    tittle: `Usuario administrador y corrección de errores. `,
    date: `02/11/2023`,
    file: `update02112023.js`
  },
  {
    id: `update18102023`,
    tittle: `Actualizaciones Visuales y Nuevas Funcionalidades`,
    date: `18/10/2023`,
    file: `update18102023.js`
  },

]

export default listUpdates